export default __webpack_public_path__ + "static/media/warmup1.196a8a26.png";